/**
* author: duxin
* date: 2020/4/3
* describe:
*/

<template>
	<div style="margin-top: -70px">
		<BannerChunk></BannerChunk>
		<div class="content">
			<!-- <div class="home-nav" :class="{'isScroll': !scrollFlag}">
				<HomeNav class="width" @on-select="onGoto" :isScroll="scrollFlag"></HomeNav>
			</div> -->
			<AboutChunk></AboutChunk>
			<!-- 我们的服务 -->
			<div class="bc-width" id="service">
				<ServiceChunk></ServiceChunk>
			</div>
			<!-- 历程 -->
			<div class="course" id="course">
				<CourseChunk class="width"></CourseChunk>
			</div>
			<!-- 团队 -->
			<TeamChunk id="team"></TeamChunk>
			<!-- 企业文化 -->
			<!-- <div class="bc-width" id="culture">
				<CultureChunk class="width"></CultureChunk>
			</div> -->
			<!-- 新闻 -->
			<NewsChunk id="news"></NewsChunk>
			<!-- 团队 -->
			<!-- <HonorChunk id="honor"></HonorChunk> -->
		</div>
	</div>
</template>

<script>
import AboutChunk from './chunks/about-me-chunk'
import BannerChunk from './chunks/banner-chunk.vue'
import ServiceChunk from './chunks/me-service-chunk.vue'
import NewsChunk from './chunks/me-news-chunk'
import HonorChunk from './chunks/honor-chunk'
import KMenu from '../../components/kllk-menu'
import HomeNav from './chunks/home-nav'

import CourseChunk from '../home/chunks/course-chunk'
import TeamChunk from '../home/chunks/team-chunk'
import CultureChunk from '../home/chunks/culture-chunk.vue'

export default {
	name: 'home',
	components: {
		AboutChunk,
		BannerChunk,
		ServiceChunk,
		NewsChunk,
		CourseChunk,
		TeamChunk,
		CultureChunk,
		HomeNav,
		HonorChunk,
	},
	props: {
		scrollFlag: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		this.ids = ['service', 'course', 'team', 'culture', 'news']
		return {}
	},
	methods: {
		onGoto(key) {
			document.getElementById(this.ids[key - 1]).scrollIntoView(true)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../style/constant.less';

.content {
	position: relative;
	.course {
		width: 100%;
		background: url('../../assets/history.png');
	}
	// 包裹的div
	.bc-width {
		width: 100%;
		background-color: #fafafa;
	}
	// 首页内部导航样式
	.home-nav {
		width: 100%;
		position: absolute;
		background-color: #fbfbfb;
		top:0px;
	}
	@media screen and (min-width: 320px) and (max-width: 480px) {
		.home-nav {
			width: 100%;
		}
	}
	// 首页一级导航滚动后，超过banner高度，显示二级导航
	.isScroll {
		position: fixed;
		z-index: 201;
	}
}
.width {
	width: @page-width;
	margin: 0 auto;
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.content {
		line-height: 1.8;
	}
	.width {
		width: 100%;
	}
}
</style>